<ap-button-link
    id="appointmentButton"
    variant="secondary"
    analyticsClick
    elementType="APPOINTMENT_BUTTON"
    [key]="buttonKey.APPOINTMENT_BUTTON"
    [wide]="true"
    [href]="'global.appointment-button.max-mortgage.url' | apContent"
    >{{ 'global.appointment-button.max-mortgage.text' | apContent }}</ap-button-link
>
